// @core/api/endpoints/userprofile/list_userprofiles_by_ids.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListUserprofilesByIDsRequest,
  ListUserprofilesResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * List user profiles by IDs
 * Retrieves multiple user profiles by their IDs in a single request. Only profiles the caller has access to view are returned; others are silently filtered out.
 */
export async function ListUserprofilesByIDs(
  data: ListUserprofilesByIDsRequest,
  options?: RequestOptions
): Promise<ListUserprofilesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/list-by-ids`;
  const requestOptions = options;
  return client.post<ListUserprofilesResponse>(requestPath, data, requestOptions);
}
